module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer-main"
  }, [(_vm.props.app) ? _c('div', {
    staticClass: "footer-main__bg"
  }, [_c('div', {
    staticClass: "footer-main__container"
  }, [_c('div', {
    staticClass: "footer-main__contact"
  }, [_c('div', {
    staticClass: "notranslate footer-main__contact--section",
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.acf.information.address)
    }
  }), _c('a', {
    staticClass: "footer-main__contact--section",
    attrs: {
      "href": "tel:+17145329700"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.acf.information.phone_display)
    }
  }), _c('div', {
    staticClass: "footer-main__social-links"
  }, _vm._l((_vm.props.app.acf.information.social_links), function(social) {
    return _c('a', {
      staticClass: "footer-main__social-link",
      attrs: {
        "href": social.link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "footer-main__social-icon",
      attrs: {
        "src": social.icon,
        "alt": "social media"
      }
    })])
  }), 0), _c('div', {
    staticClass: "footer-main__roostergrin",
    domProps: {
      "innerHTML": _vm._s(_vm.props.app.acf.information.trademark)
    }
  })]), _c('div', {
    staticClass: "footer-main__logo",
    style: ({
      backgroundImage: 'url(https://pediatricdentistorangeca.com/wp-content/uploads/H2pedo-logo-footer.png)'
    })
  }), _vm._m(0)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-main__trademarks"
  }, [_c('div', {
    staticClass: "footer-main__right"
  }, [_c('div', {
    staticClass: "footer-main__hours"
  }, [_c('p', [_vm._v("Hours of Operation")]), _vm._v("M: 8:00am-5:00pm"), _c('br'), _vm._v("T: 8:00am-5:00pm"), _c('br'), _vm._v("W: 8:00am-5:00pm"), _c('br'), _vm._v("Th: 9:00am-6:00pm")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5032803c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 575
// module chunks = 1